import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AuthState } from "../reducers/token.reducer";

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAccessToken = createSelector(
    selectAuthState,
    (state: AuthState) => state.accessToken
)

export const selectRefreshToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.refreshToken
);